<template>
  <div class="pull-right">
    <ul v-if="totalNoPages != '1' && totalNoPages != '0'" class="pagination">
      <li :class="{disabled:prevDisabled}" class="page-item">
        <a class="page-link" @click.prevent="goToPage(1)" href="#">{{firstText}}</a>
      </li>
      <li :class="{disabled:prevDisabled}" class="page-item">
        <a class="page-link" @click.prevent="prev()" href="#">{{prevText}}</a>
      </li>
      <li
        v-for="page in pages"
        v-bind:key="page"
        class="page-item"
        :class="(current_page == page)? 'active':''"
      >
        <a class="page-link" @click.prevent="goToPage(page)" href="#">{{page}}</a>
      </li>
      <li :class="{disabled:nextDisabled}" class="page-item">
        <a class="page-link" href="#" @click.prevent="next()">{{nextText}}</a>
      </li>
      <li :class="{disabled:nextDisabled}" class="page-item">
        <a class="page-link" href="#" @click.prevent="goToPage(totalNoPages)">{{lastText}}</a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: ["totPages", "apiUrl", "pageName"],
  data() {
    return {
      totalNoPages: 1,
      current_page: 1,
      pageToLoad: 1,
      prevDisabled: 1,
      nextDisabled: 0,
      pages: [],
      prevText: "<",
      nextText: ">",
      firstText: "<<",
      lastText: ">>"
    };
  },
  created() {
    // console.log(
    //   "Pagination Created",
    //   this.pageName,
    //   this.totalNoPages,
    //   this.current_page,
    //   this.pageToLoad
    // );
    var url = this.apiUrl;
    this.totalNoPages = this.totPages;
    this.$route.query.page
      ? (this.pageToLoad = parseInt(this.$route.query.page))
      : (this.pageToLoad = "1");
    url += this.pageToLoad;
    if (this.pageName !== "s1" && this.pageName !== "trending-company") {
      this.$emit("changePage", url);
    } else {
      this.$emit("changePage", { url: url, page: this.pageToLoad });
    }
  },
  methods: {
    prev() {
      this.pageToLoad = parseInt(this.current_page) - 1;
      this.current_page = this.pageToLoad;
      if (this.pageName !== "s1" && this.pageName !== "trending-company") {
        this.$router.push({
          query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
        });
      }
      this.fillTable();
    },
    goToPage(page) {
      this.pageToLoad = page;
      if (this.pageName !== "s1" && this.pageName !== "trending-company") {
        this.$router.push({
          query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
        });
      }
      this.fillTable();
    },
    next() {
      // console.log(this.$route.query);
      this.pageToLoad = parseInt(this.current_page) + 1;      
      if (this.pageName !== "s1" && this.pageName !== "trending-company") {
        this.$router.push({
          query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
        });
      }
      this.fillTable();
    },
    fillTable() {
      let url = this.apiUrl; //+"?a=1"
      // console.log(this.pageToLoad, this.current_page, this.pageToLoad != this.current_page, "adsd");
      if (this.pageToLoad != this.current_page) {
        url += this.pageToLoad;
        // console.log("URL", url);
      }
      // this.url = url;
      this.current_page = this.pageToLoad;
      if (this.pageToLoad == this.totalNoPages) {
        this.nextDisabled = 1;
      } else {
        this.nextDisabled = 0;
      }
      if (this.pageToLoad == 1) {
        this.prevDisabled = 1;
      } else {
        this.prevDisabled = 0;
      }
      if (this.pageName !== "s1" && this.pageName !== "trending-company") {
        this.$emit("changePage", url);
      } else {
        this.$emit("changePage", { url: url, page: this.pageToLoad });
      }
    }
  },
  watch: {
    totPages: function(value) {
      // console.log("Pages changed", value);
      this.totalNoPages = value;
      this.prevDisabled = this.pageToLoad == 1;
      this.nextDisabled = this.current_page == this.totalNoPages;
      this.current_page = this.pageToLoad;
      // console.log("TotPages Current Page", this.current_page);
      let i = 10;
      let page = parseInt(this.current_page) - 2;
      if (page <= 0) page = 1;
      this.pages = [];
      while (i) {
        // console.log("PAGE", page, parseInt(page));
        this.pages.push(parseInt(page));
        if (value <= page) break;
        page++;
        i--;
      }
    },
    // pageName: function(value) {
    //   var url = this.apiUrl;
    //   console.log(this.url.indexOf(value), this.$route.query);
    //   this.$route.query.page
    //     ? (this.pageToLoad = parseInt(this.$route.query.page))
    //     : (this.pageToLoad = "1");
    //   url += this.pageToLoad;
    //   this.current_page = this.pageToLoad;
    //   this.$emit("changePage", url);
    // },
    $route(to, from) {
      this.pageToLoad = to.query.page;
      this.current_page = this.pageToLoad;
      this.prevDisabled = this.current_page == 1;
      this.nextDisabled = this.current_page == this.totalNoPages;
      // console.log(
      //   "watch route",
      //   to.query,
      //   this.current_page == 1,
      //   "==",
      //   this.current_page == this.totalNoPages
      // );
      // this.fetchData(to.query)
      let i = 5;
      let page = parseInt(this.current_page) - 2;
      if (page <= 0) page = 1;
      this.pages = [];
      while (i) {
        // console.log("PAGE", page, parseInt(page));
        this.pages.push(parseInt(page));
        if (this.totalNoPages <= page) break;
        page++;
        i--;
      }
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/pagination.vue